import type { JSX } from "react";
import type { ExporterType } from "../client/generated";
import { Icon } from "@mdi/react";
import { mdiCheck } from "@mdi/js";
import { CommandItem } from "@acdc2/ui/components/command";

type Props = {
  exporterType: ExporterType;
  isSelected: boolean;
  onSelect: (exporterType: ExporterType) => void;
};

export function DocumentExportCommandItem({
  exporterType,
  isSelected,
  onSelect,
}: Props): JSX.Element {
  return (
    <CommandItem
      keywords={[exporterType]}
      onSelect={() => onSelect(exporterType)}
    >
      {exporterType}
      {isSelected ? (
        <Icon path={mdiCheck} size="1rem" className="ml-auto" />
      ) : null}
    </CommandItem>
  );
}
